require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-neustift-bei-guessing.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-neustift-bei-guessing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-neustift-bei-guessing!./.cache/json/betreuungseinrichtungen-guessing-neustift-bei-guessing.json
// module id = 897
// module chunks = 231608221292675